// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"fb774e9c","170":"11250f3c","313":"fe5e2b13","357":"2f9cbc22","426":"b51217bf","458":"4de0e20b","564":"a300838a","574":"0eaeac8b","926":"2c65de51"}[chunkId] + ".chunk.js";
};